import { useRef, useState, type DragEvent } from "react";
import { buttonClass } from "../../components/ui/Button";
import { cx } from "../../components/ui/cx";
import { ACCEPT_ATTR } from "../../lib/upload/content-type";

/** A native file input wearing a drop zone. Keyboard users get the button; mouse users can also drop files. */
export function DropZone({ onFiles, disabled }: { onFiles: (files: File[]) => void; disabled?: boolean }) {
  const input = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const drop = (e: DragEvent) => {
    e.preventDefault();
    setOver(false);
    if (!disabled && e.dataTransfer.files.length) onFiles([...e.dataTransfer.files]);
  };
  return (
    <div
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={drop}
      className={cx("flex flex-col items-center gap-3 rounded-xl border-2 border-dashed border-ink p-8 text-center motion-safe:transition-[background-color,transform] motion-safe:duration-300", over ? "scale-[1.01] bg-accent-tint" : "bg-card")}
    >
      <p className="font-display text-xl font-bold">Drop video files here</p>
      <p className="text-muted">MP4, MOV, MKV, WebM, AVI, MPEG or TS. Large files are fine: they upload in parts.</p>
      <label className={buttonClass("primary", "md", disabled ? "pointer-events-none opacity-50" : undefined)}>
        choose files
        <input ref={input} type="file" multiple accept={ACCEPT_ATTR} disabled={disabled} className="sr-only"
          onChange={(e) => { if (e.target.files?.length) onFiles([...e.target.files]); e.target.value = ""; }} />
      </label>
    </div>
  );
}
